import React from 'react';
import { StorylineState } from "../../../store/storyline/types";
import { connect } from "react-redux";
import { RootState } from "../../../store";
import { updateParameterValue } from "../../../store/storyline/actions";
import { DateTimePicker as BaseDateTimePicker } from "../../../shared/components";
import { Moment, default as moment } from 'moment';

interface Props {
    storyline: StorylineState;
    updateParameterValue: typeof updateParameterValue;
    name: string;
    format?: string;
    minDateTime?: string | Date | Moment;
    maxDateTime?: string | Date | Moment;
    onChange?: (value: Moment) => void
}

export function DateTimePicker(props: Props) {
    const { storyline, updateParameterValue, name, format, minDateTime, maxDateTime, onChange, ...other } = props;
    const [value, setValue] = React.useState(storyline.parameterValues.get(name) || null);

    const handleChange = (newValue: Moment) => {
        updateParameterValue(name, newValue);
        setValue(newValue);
        onChange?.(newValue);
    };

    React.useEffect(() => {
        if (storyline.parameterValues.has(name)) {
            const newValue = storyline.parameterValues.get(name);
            if (newValue !== value) {
                setValue(newValue);
            }
        }
    }, [storyline.parameterValues]);

    return (
        <BaseDateTimePicker
            {...other}
            minDateTime={minDateTime ? moment(minDateTime) : undefined}
            maxDateTime={maxDateTime ? moment(maxDateTime) : undefined}
            value={value}
            onChange={handleChange}
            inputFormat={format || "YYYY/MM/DD HH:mm"}
        />
    );
}

export default connect(
    (state: RootState) => ({
        storyline: state.storyline
    }),
    { updateParameterValue: updateParameterValue as any })(DateTimePicker);